import React, {useEffect, useState} from 'react'
import styled from 'styled-components';
import { Data, Parameter } from '../types';
import i18n from 'live/services/i18n';

type IProps = {
    paramActiveID: number,
    parameters: Data[]
}

export const InfoWindowTemplate = ({paramActiveID, parameters}: IProps): JSX.Element => {

    useEffect(() => {          
        if(parameters) setParameterActive(parameters?.find(ele => ele.parameterID === paramActiveID))
    }, [paramActiveID, parameters])

    const [parameterActive, setParameterActive] = useState<Data>()

    const Parameter = ({active, title, data}) => {
        return  <StyleParameter active={active}>
                    <div className="parameter-title">{i18n(title)}</div>

                    {
                        data && Object.keys(data).map((key) => {
                            return <div className="parameter-item" key={key}>
                                        <span className="parameter-key">{i18n(key)}:</span>
                                        <span className="parameter-value">{i18n(data[key])}</span>
                                    </div>
                        })
                    }
                </StyleParameter>
    }

    return <Wrapper>
        <div className='title-info-window'>{i18n('Region Performance')}</div>

        {
            parameterActive && <Parameter active={true} title={parameterActive?.title} data={parameterActive?.data}/>
        }
        
        <Divider />

        <div className="title-info-window">{i18n('Others Data')}</div>

        {
            parameters?.filter(ele => ele.parameterID != paramActiveID)
            .map(({title, data}, index) => {
                return <Parameter active={false} key ={index} title={title} data={data}/>
            })
        }
        
    </Wrapper>
}

const Wrapper = styled.div`
    width: 240px;
    max-height: 240px;
    font-style: normal;
    color: ${({theme}) => theme['gray-800']};

    .title-info-window{
        font-size: 14px;
        font-weight: 600;
        line-height: 120%; 
        margin-bottom: 16px;
        text-transform: capitalize;
        font-family: ${({theme}) => theme['font-semibold']};
    }

    .parameter-title{
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 8px;
        line-height: normal;
        font-family: ${({theme}) => theme['font-semibold']};
    }

    .parameter-key{
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        margin-right: 4px;
        font-family: ${({theme}) => theme['font-regular']};
    }

    .parameter-value{
        font-size: 12px;
        font-weight: 600;
        line-height: normal;
        font-family: ${({theme}) => theme['font-semibold']};
    }
`

const Divider = styled.div`
    border: 0;
    margin: 16px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
`

const StyleParameter = styled.div`
    margin-bottom: ${({active}) => active == true ? "0" : "24px"};

    &:last-of-type{
            margin-bottom: 0px;
    }

    .parameter-item{
        margin-bottom: 4px;

        &:last-of-type{
            margin-bottom: 0px;
        }
    }
`
